// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"7777c9fa","479":"3d9724d3","719":"0e45fe4c"}[chunkId] + ".chunk.css";
};